import styled from 'styled-components';
import DocsCreateCarrier from './DocsCreateCarrier';

export default styled(DocsCreateCarrier)`
  .docs-create-carrier {
    display: flex;
    flex-direction: column;

    &__body {
      background-color: var(--grey100);
      padding: 3.1rem 2rem;
    }

    &__section {
      display: flex;
      flex-direction: column;
      margin-bottom: 2rem;

      &:last-of-type {
        margin-bottom: 0;
      }
    }

    &__section-title {
      font-size: 1.2rem;
      font-weight: bold;
      margin: 0 0 1rem;
      text-transform: uppercase;
    }

    &__field {
      flex-grow: 1;
      margin-bottom: 1rem;
      margin-right: 1rem;

      &--large {
        width: 65%;
      }

      &:last-of-type {
        margin-right: 0;
      }
    }

    &__inline-fields {
      display: flex;
      justify-content: space-between;
    }

    &__footer {
      display: flex;
      justify-content: flex-end;
    }

    &__radio-error {
      color: var(--error900);
      margin: 0.5rem 0;
    }

    &__footer {
      padding: 2rem;
    }

    &__footer-error {
      background-color: var(--error100);
      color: var(--error900);
      padding: 2rem;
    }
  }
`;
